
<!-- Contacts section -->
<main class="flex-shrink-0">
  <div class="contacts-content" style="margin-top: 100px; padding-bottom: 100px">
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <span translate class="title">kazakhstan.nav_contacts</span>
        </div>
        <div class="col">
          <div class="line"></div>
        </div>
      </div>
      <br>
      <div class="row mt-2">
        <div class="col-lg-4 footer-info" id="contact2" style="padding: 30px;">
          <div class="phone-number">
            <i style="font-size: large; color: #002960;" class="fa fa-phone" aria-hidden="true"></i>
            <span> +7 701 426 7642</span>
            <!-- <br>
            <span>+7 7172 111 11 11</span> -->
          </div>
          <br>
          <div class="mail">
            <i style="font-size: large; color: #002960;" class="fa fa-envelope" aria-hidden="true"></i>
            <span> 9kumalak@gmail.com</span>
          </div>
          <br>
          <div class="address">
            <i style="font-size: large; color: #002960;" class="fa fa-map-marker" aria-hidden="true"></i>
            <span> Республика Казахстан</span> <br>
            <span>010000, город Астана</span> <br>
            <span>ул. Мамбетова, 14 </span>
          </div>
        </div>

        <div class="col-lg-8">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2502.1376270101537!2d71.4221972156435!3d51.16125207957965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x424586d1ffa50447%3A0xf908789d23ae9fdb!2z0YPQuy4g0JDQt9C10YDQsdCw0LnQttCw0L3QsCDQnNCw0LzQsdC10YLQvtCy0LAgMTQsINCd0YPRgC3QodGD0LvRgtCw0L0gMDEwMDAw!5e0!3m2!1sru!2skz!4v1615806415309!5m2!1sru!2skz"
            width="100%" height="320" frameborder="0" style="border:0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</main>
<!-- Partners section -->
<section #partners id="partners">
  <app-partners></app-partners>
</section>
